import hash from 'object-hash'
import { decorators, CONSTANTS } from '@sohohouse/platform-resources'
import { platformGetters } from '~/helpers/store'
import { SEARCHES } from '../constants'
import filterGetters from './filters'

const Event = decorators.dh.Event
const DateTime = decorators.shared.DateTime
const { DAY } = CONSTANTS.DATE_TIME_TYPES

export default {
  ...platformGetters,
  ...filterGetters,

  eventById: (s, getters) => id =>
    getters.resourceById(id) ? new Event(getters.resourceById(id)) : null,

  eventsBySearch: ({ meta }, getters) => (eventView, params) => {
    delete params.page

    const withEventViewFilters = getters.applyEventViewFilters({ eventView, params })
    const hashedSearch = hash(withEventViewFilters)

    const thisSearch = meta.searches[hashedSearch]
    if (!thisSearch) {
      return []
    }

    return thisSearch.pages.reduce(
      (acc, thisPage) => [...acc, ...thisPage.map(eventId => {
        const event = new Event(getters.resourceById(eventId))
        return event
      })],
      []
    )
  },

  getSearch: (_, getters) => (eventView, params) => {
    const withEventViewFilters = getters.applyEventViewFilters({ eventView, params })
    const search = getters.cachedSearch(withEventViewFilters)
    return search
  },

  getFetching: (_, getters) => (eventView, params) => {
    const search = getters.getSearch(eventView, params)
    return search ? search.fetching : false
  },

  getFailed: (_, getters) => (eventView, params) => {
    const search = getters.getSearch(eventView, params)
    return search ? search.failed : false
  },

  featuredEvents: (_, getters) => eventView => getters.eventsBySearch(eventView, SEARCHES.FEATURED),
  featuredFetching: (_, getters) => eventView => getters.getFetching(eventView, SEARCHES.FEATURED),
  featuredFailed: (_, getters) => eventView => getters.getFailed(eventView, SEARCHES.FEATURED),

  historyEvents: (_, getters) => eventView => getters.eventsBySearch(eventView, SEARCHES.HISTORY),
  historyFetching: (_, getters) => eventView => getters.getFetching(eventView, SEARCHES.HISTORY),
  historyFailed: (_, getters) => eventView => getters.getFailed(eventView, SEARCHES.HISTORY),

  allEvents: (_, getters) => eventView => getters.eventsBySearch(eventView, SEARCHES.ALL),
  allFetching: (_, getters) => eventView => getters.getFetching(eventView, SEARCHES.ALL),
  allFailed: (_, getters) => eventView => getters.getFailed(eventView, SEARCHES.ALL),

  inductionEvents: (_, getters, __, globalGetters) => {
    const date = new DateTime()
    const localVenue = globalGetters['user/account/localHouse']

    if (!localVenue.id) return []

    return Object.values(getters.resources)
      .map(event => new Event(event))
      .filter(e =>
        e.startsAt.isAfter(date) &&
        e.bookable === CONSTANTS.EVENT_BOOKABLE.IS_BOOKABLE &&
        e.resource.resourceType === CONSTANTS.EVENT_TYPES.INDUCTION &&
        e.venue.id === localVenue.id &&
        e.state === CONSTANTS.EVENT_STATES.OPEN_FOR_BOOKING
      )
  },

  inductionSevenDayEvents: (s, getters) => {
    const events = getters.inductionEvents
    const date = new DateTime()
    return events.filter(e => date.diff(e.startsAt, DAY) <= 8)
  },

  inductionThirtyDayEvents: (_, getters) => {
    const events = getters.inductionEvents
    const date = new DateTime()
    return events.filter(e =>
      date.diff(e.startsAt, DAY) <= 30 &&
      date.diff(e.startsAt, DAY) > 8
    )
  },
  inductionEventsFetching: s => s.meta.inductionEventsFetching,

  cachedSearch: ({ meta }) => params => {
    const hashedSearch = hash(params)
    return meta.searches[hashedSearch]
  },

  allEventsFetched: (_, getters) => ({ eventView }) => {
    const withEventViewFilters = getters.applyEventViewFilters({ eventView, params: SEARCHES.ALL })
    return getters.isSearchComplete(withEventViewFilters)
  },

  isSearchComplete: (_, getters) => params => {
    if (getters.isSearchCached(params)) {
      const search = getters.cachedSearch(params)
      return search.pages.length === search.totalPages
    }
    return false
  },

  isSearchCached: ({ meta }) => params => {
    const hashedSearch = hash(params)

    return typeof meta.searches[hashedSearch] !== 'undefined'
  },

  isSearchEmpty: ({ meta }, getters) => params => {
    const hashedSearch = hash(params)

    return getters.isSearchCached(params) && meta.searches[hashedSearch].pages[0].length === 0
  },

  happeningNowFetching: ({ meta }) => meta.searches.happeningNowFetching,

  happeningNowFailed: ({ meta }) => meta.searches.happeningNowFailed,

  happeningNow: ({ meta }) => {
    const { happeningNow } = meta.searches

    return happeningNow ? happeningNow.map(e => new Event(e)) : []
  },

  pastEvents: ({ meta }) => meta.searches.pastEvents || []
}
